// WaiverViewerLayout.jsx
//Route: /business/waiverviewer/:waiverId

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import API_URL from "../../api/API";
import { Outlet } from "react-router-dom";

import WaiverViewerTopBar from "./components/WaiverViewerTopBar";
import WaiverHeader from "./components/WaiverHeader";
import WaiverTabs from "./components/WaiverTabs";
import WaiverFooter from "./components/WaiverFooter";

const WaiverViewerLayout = () => {
  const { waiverId } = useParams();
  const { business } = useBusinessAuthContext();
  const navigate = useNavigate();

  const [waiver, setWaiver] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!business) {
      navigate("/business/login");
      return;
    }

    const loadWaiver = async () => {
      try {
        const res = await fetch(
          `${API_URL.BUSINESS_WAIVER_BY_ID}/${waiverId}`,
          {
            headers: {
              Authorization: `Bearer ${business.token}`,
              "x-session-id": business.sessionId,
              "x-frontend-url": window.location.pathname,
            },
          }
        );

        const data = await res.json();

        if (data.success) {
          setWaiver(data.waiver);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadWaiver();
  }, [waiverId, business, navigate]);

    if (loading || !waiver) {
        return (
            <div className="min-h-screen flex items-center justify-center">
            Loading waiver...
            </div>
        );
    }

  return (
    <div className="h-screen flex bg-background">
      <Sidebar />

      <div className="flex-1 overflow-auto py-10">
        <div className="max-w-7xl mx-auto px-6">

          
        <WaiverViewerTopBar
            waiver = {waiver}
        />

        {/* Header */}
        <WaiverHeader
            waiver = {waiver}
        />
          

        {/* Tabs */}
        <WaiverTabs
        />
        
        <Outlet
            context={{
                waiver,
            }}
        />

        {/* Footer */}
        <WaiverFooter
            waiver = {waiver}
        />
          
        </div>
      </div>
    </div>
  );
};

export default WaiverViewerLayout;